import { getDataUrl } from './apiConfig';

export const LAND_USES = ['Agriculture', 'Forest', 'Urban'];

export const WORKSHOP_NAME_ALIASES = {
  'Grand Farm': 'Vienna - Grand Farm',
  'Fuchsenbigl': 'Fuchsenbiegl',
  'Lynx Land': 'Central Region'
};

export const PUBLICATION_DIAGRAMS = {
  challenges: {
    title: 'Land-use-specific radar: soil health challenges',
    shortTitle: 'Challenges',
    file: '3.2.1 soil health challenges.png',
    text: 'A grouped overview of soil health challenges identified in the workshop responses.',
    badge: 'Specific to this land use'
  },
  objectives: {
    title: 'Analysis summary: soil health objectives',
    shortTitle: 'Objectives',
    file: '3.3.1 soil health objectives.png',
    text: 'A grouped overview of soil health objectives emerging from the workshop responses.',
    badge: null
  },
  needs: {
    title: 'Analysis summary: stakeholder needs',
    shortTitle: 'Needs',
    file: '3.4.1 stakeholder needs.png',
    text: 'A grouped overview of stakeholder needs identified across workshop responses.',
    badge: null
  },
  soilFunctionVotes: {
    title: 'Soil function votes',
    shortTitle: 'Soil function votes',
    file: '3.3.4 soil function votes.png',
    text: 'A land-use level overview of workshop voting on soil functions.',
    badge: null
  }
};

export const OVERVIEW_DIAGRAM_KEYS = [
  'challenges',
  'objectives',
  'needs',
  'soilFunctionVotes'
];

const WORKSHOP_METHOD_TEXT = 'Recurring themes were first identified from pooled responses in the corresponding land-use context; this workshop was then scored on a 0-5 scale for how strongly each theme was directly expressed, with repeated scoring runs averaged where present.';

export function getPublicationWorkshopName(workshopName) {
  return WORKSHOP_NAME_ALIASES[workshopName] || workshopName;
}

export function getPublicationAssetUrl(parts) {
  return encodeURI(`${getDataUrl()}/publication_analysis/${parts.join('/')}`);
}

export function getLandUseOverviewFigure(landUse, diagramKey) {
  const diagram = PUBLICATION_DIAGRAMS[diagramKey];
  return {
    landUse,
    title: diagram.shortTitle,
    src: getPublicationAssetUrl([landUse, diagram.file]),
    alt: `${diagram.title} for ${landUse}`,
    text: diagram.text
  };
}

export function getWorkshopPublicationFigures(workshop, diagramKey) {
  if (!workshop) {
    return [];
  }

  const diagram = PUBLICATION_DIAGRAMS[diagramKey];
  const publicationWorkshopName = getPublicationWorkshopName(workshop.name);
  const landUses = Array.isArray(workshop.land_uses) ? workshop.land_uses : [];

  return landUses
    .filter(landUse => LAND_USES.includes(landUse))
    .map(landUse => {
      const landUseContextText = landUses.length > 1 ? ` This workshop is shown in the ${landUse} land-use context.` : '';

      return {
        landUse,
        title: landUses.length > 1 ? `${diagram.title} (${landUse})` : diagram.title,
        src: getPublicationAssetUrl([landUse, publicationWorkshopName, diagram.file]),
        alt: `${diagram.title} for ${workshop.name} (${landUse})`,
        badge: diagram.badge,
        text: `${diagram.text} ${WORKSHOP_METHOD_TEXT}${landUseContextText}`
      };
    });
}
